import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import RaceHeaderInfo from './RaceHeaderInfo'

class RaceHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      width: 0
    }
  }
  componentDidMount () {
    let width = this.parent.clientWidth / this.props.race.event.races.length
    this.setState({width})
  }

  render () {
    return (
      <div className='header_race'>
        <div className='row'>
          <div className='col-3 logo_img center'>
            <img src={process.env.REACT_APP_UPLOADS + this.props.race.event.logo} alt='Logo' />
          </div>
          <div className='col-9'>
            <h2 className='center'>
              <Link to={`/${this.props.race.event.slug}`}>{this.props.race.event.name}</Link>
            </h2>
            <div ref={ref => { this.parent = ref }}>
              <ul className='navbar_races'>
                {this.props.race.event.races.map(r => <li key={r.id} style={{ backgroundColor: r.color, width: this.state.width }}>
                  <RaceHeaderInfo race={r} eventSlug={this.props.race.event.slug} width={this.state.width} />
                </li>)}
              </ul>
            </div>
          </div>
        </div>
        <h2 className='center'>Results : {this.props.race.name}</h2>
        <div className='center'>
          <ul className='navbar_cat'>
            <li><Link to={`/${this.props.race.event.slug}/${this.props.race.id}`}>All</Link></li>
            <li><Link to={`/${this.props.race.event.slug}/${this.props.race.id}/M`}>Men</Link></li>
            <li><Link to={`/${this.props.race.event.slug}/${this.props.race.id}/F`}>Women</Link></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default RaceHeader
